/**
 * Returns a new set from elements that exist in both of the input sets.
 *
 * Note: Set intersection will be available natively in ES2026, at which point we could retire this utility.
 */
export function intersection<T>(a: Set<T>, b: Set<T>): Set<T> {
  const result = new Set<T>();
  for (const element of a) {
    if (b.has(element)) {
      result.add(element);
    }
  }
  return result;
}
